import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { BsGrid3X3GapFill, BsFillEnvelopeFill } from "react-icons/bs";
import BellIconWithNotifications, {
  NotificationWidget,
} from "./notifications/notificationwidget";
import { IoMap } from "react-icons/io5";
import { FiRefreshCw } from "react-icons/fi";
import RenewalsIcon from "../../assets/images/renewals-icon.svg";
import FailedSubmissions from "../../assets/images/failedsubmissions-icon.svg";
import PendingReview from "../../assets/images/pendingreview-icon.svg";
import "bootstrap/dist/css/bootstrap.min.css";

function Dashboard() {
  const [renewalsToday, setRenewalsToday] = useState(15);
  const [failedSubmissions, setFailedSubmissions] = useState(10);
  const [pendingReview, setPendingReview] = useState(36);
  const [recentLogs, setRecentLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setRecentLogs([
      {
        id: 1,
        controlNo: "48721",
        policyNumber: "S0002PR000589-01",
        insuredName: "Green Hills Townhome Association",
        broker: "Summit Risk Group",
        agent: "Liam Ortega",
        expiryDate: "2025-08-01",
      },
      {
        id: 2,
        controlNo: "50468",
        policyNumber: "P0015UR001379-03",
        insuredName: "John Doe",
        broker: "Summit Risk Group",
        agent: "Liam Ortega",
        expiryDate: "2025-08-01",
      },
    ]);
    setLoading(false);
  }, []);

  const handleViewLog = (e, logId) => {
    e.preventDefault();
    console.log(`View log ${logId}`);
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Header with Dashboard title and Quick Access in same row */}
      <div
        className="dashboard-title mb-3"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <h1>Dashboard</h1>
        <div className="d-flex align-items-center gap-3">
          <BellIconWithNotifications />
          <div className="dropdown-container">
            <Dropdown>
              <Dropdown.Toggle
                variant="light"
                id="dropdown-basic"
                className="rounded-circle border-0 bg-transparent"
              >
                <div
                  className="menu-icon"
                  style={{
                    fontSize: "1.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <BsGrid3X3GapFill />
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdown-menu-custom">
                <Dropdown.Item
                  href="/dashboard"
                  className="dropdown-item-custom"
                >
                  <BsFillEnvelopeFill className="dropdown-icon" /> Quote/Bind
                  Email
                </Dropdown.Item>
                <Dropdown.Item
                  href="/geographical-concentration"
                  className="dropdown-item-custom"
                >
                  <IoMap className="dropdown-icon" /> Geographical Concentration
                </Dropdown.Item>
                <Dropdown.Item
                  href="/renewals-dashboard"
                  className="dropdown-item-custom"
                >
                  <FiRefreshCw className="dropdown-icon" /> Renewals
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
      {/* Quick Access moved to same row */}
      <div className="qa mb-3">
        <h4>Quick Access:</h4>
        <a href="/renewals-logs" className="btn btn-primary">
          Renewal Logs
        </a>
        <button
          className="btn btn-primary"
          onClick={() => {
            // Dispatch custom event to open settings submenu
            window.dispatchEvent(new Event("openSettingsSubmenu"));
          }}
        >
          Settings
        </button>
      </div>

      {/* Stats Row */}
      <div className="renewals-grid mb-3">
        <div className="renewals-card shadow-sm">
          <div>
            <h3>Renewals Today</h3>
            <h2>{renewalsToday}</h2>
          </div>
          <img src={RenewalsIcon} alt="Image goes here" />
        </div>

        <div className="renewals-card shadow-sm">
          <div>
            <h3>Failed Submissions</h3>
            <h2>{failedSubmissions}</h2>
          </div>
          <img src={FailedSubmissions} alt="Image goes here" />
        </div>

        <div className="renewals-card shadow-sm">
          <div>
            <h3>Pending Review</h3>
            <h2>{pendingReview}</h2>
          </div>
          <img src={PendingReview} alt="Image goes here" />
        </div>
      </div>

      {/* Recent Logs Table */}
      <div className="bg-white rounded shadow-sm p-4">
        <h3 className="subtitle mb-3">Recent Logs</h3>
        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th>#</th>
                <th>Control No</th>
                <th>Policy Number</th>
                <th>Insured Name</th>
                <th>Broker</th>
                <th>Agent</th>
                <th>Expiry Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {recentLogs.map((log, index) => (
                <tr key={log.id}>
                  <td>{index + 1}</td>
                  <td>{log.controlNo}</td>
                  <td>{log.policyNumber}</td>
                  <td>{log.insuredName}</td>
                  <td>{log.broker}</td>
                  <td>{log.agent}</td>
                  <td>{log.expiryDate}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={(e) => handleViewLog(e, log.id)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
